import script from "./calendar-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-widget.vue?vue&type=script&setup=true&lang=js"

import "./calendar-widget.vue?vue&type=style&index=0&id=fb182b44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb182b44"]])

export default __exports__